import * as React from 'react';
import { noop } from 'lodash';
import { InputNumber, Slider } from '@osui/ui';
import { prefixCls } from '../../utils';
import './SliderWithNumberBox.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InnerSliderWithNumberBox(props) {
  const {
    value,
    onChange,
    min,
    max,
    tailLabel,
    sliderWidth,
    numberWidth,
    step,
    status
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: `${prefixCls}-slider-with-number`,
    children: [/*#__PURE__*/_jsx(Slider, {
      style: {
        width: sliderWidth,
        marginRight: 10
      },
      value: value,
      onChange: onChange,
      min: min,
      max: max,
      step: step
    }), /*#__PURE__*/_jsx(InputNumber, {
      width: numberWidth,
      value: value,
      onChange: onChange,
      min: min,
      max: max,
      status: status
    }), tailLabel && /*#__PURE__*/_jsx("div", {
      className: `${prefixCls}-slider-with-number-tailLabel`,
      children: tailLabel
    }), min != null && max != null && /*#__PURE__*/_jsx("div", {
      className: `${prefixCls}-slider-with-number-range`,
      children: `范围: ${min}~${max}`
    })]
  });
}
InnerSliderWithNumberBox.displayName = "InnerSliderWithNumberBox";
InnerSliderWithNumberBox.defaultProps = {
  onChange: noop,
  sliderWidth: 240,
  numberWidth: 60
};
export const SliderWithNumberBox = InnerSliderWithNumberBox;
//# sourceMappingURL=es/components/SliderWithNumberBox/SliderWithNumberBox.js.map